/* ============================================================
   SHINE & STYLE — features carried over from the live store
   Tabbed best-seller carousel, cart drawer, region picker.

   All three degrade: the carousel is a native scroll container,
   the drawer has a real cart page behind it, and the region
   picker starts closed with its state in the markup.
   ============================================================ */
(function () {
  'use strict';

  /* ---------------------------------------------------------
     Tabbed carousel
     --------------------------------------------------------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-carousel]'), function (root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-panel]'));
    var prev = root.querySelector('[data-car-prev]');
    var next = root.querySelector('[data-car-next]');

    function activePanel() {
      return panels.filter(function (p) { return !p.hidden; })[0] || panels[0];
    }

    function viewport() {
      var p = activePanel();
      return p ? p.querySelector('[data-car-viewport]') : null;
    }

    /* Disable the arrows at each end rather than letting them
       click into nothing. */
    function syncArrows() {
      var v = viewport();
      if (!v || !prev || !next) return;
      var max = v.scrollWidth - v.clientWidth - 2;
      prev.disabled = v.scrollLeft <= 2;
      next.disabled = v.scrollLeft >= max;
    }

    function step(dir) {
      var v = viewport();
      if (!v) return;
      // Scroll by whole cards, not a fixed pixel amount, so the
      // snap points still line up at every breakpoint.
      var card = v.firstElementChild;
      var w = card ? card.getBoundingClientRect().width + 16 : v.clientWidth * 0.8;
      var per = Math.max(1, Math.floor(v.clientWidth / w));
      v.scrollBy({ left: dir * w * per, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    panels.forEach(function (p) {
      var v = p.querySelector('[data-car-viewport]');
      if (v) v.addEventListener('scroll', syncArrows, { passive: true });
    });

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-tab');
        tabs.forEach(function (t) {
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.hidden = p.getAttribute('data-panel') !== key;
        });
        // Cards in a hidden panel were never seen by the scroll
        // observer, so they would stay at opacity 0 when shown.
        var shown = activePanel();
        if (shown) {
          Array.prototype.forEach.call(
            shown.querySelectorAll('[data-reveal]'),
            function (el) { el.classList.add('is-in'); }
          );
        }
        syncArrows();
      });
    });

    window.addEventListener('resize', syncArrows, { passive: true });
    syncArrows();
  });

  /* ---------------------------------------------------------
     Cart drawer
     --------------------------------------------------------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOverlay = document.querySelector('[data-cart-overlay]');
  var cartLast = null;

  function openCart() {
    if (!cartDrawer) return;
    cartLast = document.activeElement;
    cartDrawer.classList.add('is-open');
    cartDrawer.removeAttribute('inert');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.classList.add('ss-locked');
    var close = cartDrawer.querySelector('[data-cart-close]');
    if (close) close.focus();
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('inert', '');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.classList.remove('ss-locked');
    if (cartLast && cartLast.focus) cartLast.focus();
  }

  if (cartDrawer) {
    cartDrawer.setAttribute('inert', '');

    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-open]'), function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        openCart();
      });
    });

    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-close]'), function (el) {
      el.addEventListener('click', closeCart);
    });

    if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cartDrawer.classList.contains('is-open')) closeCart();
    });

    // Adding from anywhere on the page opens the drawer, which is
    // the confirmation that the click did something.
    Array.prototype.forEach.call(document.querySelectorAll('[data-quick-add]'), function (btn) {
      btn.addEventListener('click', function () { window.setTimeout(openCart, 260); });
    });
  }

  /* ---------------------------------------------------------
     Region and language picker
     --------------------------------------------------------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-region]'), function (root) {
    var btn = root.querySelector('[data-region-btn]');
    var label = root.querySelector('[data-region-label]');
    var flag = root.querySelector('[data-region-flag]');
    if (!btn) return;

    function close() {
      root.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    }

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = root.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-country]'), function (opt) {
      opt.addEventListener('click', function () {
        Array.prototype.forEach.call(root.querySelectorAll('[data-country]'), function (o) {
          o.setAttribute('aria-checked', 'false');
        });
        opt.setAttribute('aria-checked', 'true');
        if (label) label.textContent = opt.getAttribute('data-country');
        if (flag) flag.textContent = opt.getAttribute('data-flag') || '';
        close();
      });
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-lang]'), function (opt) {
      opt.addEventListener('click', function () {
        Array.prototype.forEach.call(root.querySelectorAll('[data-lang]'), function (o) {
          o.setAttribute('aria-checked', 'false');
        });
        opt.setAttribute('aria-checked', 'true');
        close();
      });
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  });
})();
